import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import router from './router'
import store from './store'
import App from './App.vue'
import '@/assets/scss/main.scss'
import VueAxios from 'vue-axios'
import Axios from 'axios'
import VueSlick from 'vue-slick'
import ConsentManagerPlugin from './plugin/consent-manager'
import AnalyticsPlugin from './plugin/analytics'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueAxios, Axios)
Vue.use(VueSlick)
Vue.use(router)
Vue.use(ConsentManagerPlugin)
Vue.use(AnalyticsPlugin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
